import { BuildingContactRoleView } from '@api-proxies';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class BuildingContactRoleEntity<TEntityDestination>
    implements IComponentEditorEntity<BuildingContactRoleView, TEntityDestination>
{
    constructor(readonly buildingContactRoleService: BuildingContactRoleService) {}

    abstract toDestination(entity: BuildingContactRoleView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): BuildingContactRoleView;

    abstract getSource(entityType: EntityTypes): Promise<BuildingContactRoleView[]>;
}
